<template>
  <div class="fixed top-0 left-0 right-0 bg-custom-blue-500 text-white px-4 z-10 shadow-md h-20 md:h-12">
    <div class="max-w-7xl mx-auto flex flex-row items-center justify-between h-20 md:h-12 py-2 md:py-0 gap-2 md:gap-0">
      <div class="flex items-center space-x-2 md:space-x-3">
        <i class="bx bx-info-circle text-xl md:text-2xl flex-shrink-0" />
        <span class="font-medium text-sm md:text-base">Företrädesemission 2026 - Teckningsperiod: 12-26 januari 2026</span>
      </div>
      <router-link
        to="/foretradesemission-2026"
        class="bg-white text-custom-blue-500 hover:bg-gray-100 font-bold py-1 px-4 md:px-6 rounded transition-colors whitespace-nowrap text-sm md:text-base"
      >
        Läs mer
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightsIssueBanner'
}
</script>

<style scoped>
</style>
